import {
  animate,
  AnimationEvent,
  keyframes,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Input } from '@angular/core';

import { Subject } from 'rxjs';
import { filter, first } from 'rxjs/operators';

@Component({
  selector: 'rt-text-swap',
  template: `
    <ng-container *ngIf="!isHtml">
      {{ animatedText }}
    </ng-container>
    <ng-container *ngIf="isHtml">
      <div [innerHTML]="animatedText"></div>
    </ng-container>
  `,
  styles: [
    `
      :host {
        display: inline-block;
      }
    `,
  ],
  host: {
    '[@toggle]': 'state',
    '(@toggle.done)': 'onAnimationDone($event)',
  },
  animations: [
    trigger('toggle', [
      state('initial', style({})),
      state('in', style({ opacity: 1, transform: 'translateX(0)' })),
      state('out', style({ opacity: 0, transform: 'translateX(100%)' })),
      transition('* => in', [
        animate(
          '0.43s ease',
          keyframes([
            style({ opacity: 0, transform: 'translateX(100%)', offset: 0 }),
            style({ opacity: 1, transform: 'translateX(0)', offset: 1.0 }),
          ]),
        ),
      ]),
      transition('* => out', [
        animate(
          '0.3s ease',
          keyframes([
            style({ opacity: 1, transform: 'translateX(0)', offset: 0 }),
            style({ opacity: 0, transform: 'translateX(-100%)', offset: 1 }),
          ]),
        ),
      ]),
    ]),
  ],
  standalone: true,
  imports: [NgIf],
})
export class TextSwapComponent {
  @Input() public isHtml: boolean = false;

  public animatedText: string | null = null;
  public state: 'initial' | 'out' | 'done' | 'in' = 'initial';

  @Input()
  public set text(text: string) {
    if (this.animatedText) {
      this.state = 'out';
      this.animationState$
        .asObservable()
        .pipe(
          filter($event => $event.toState === 'out' && $event.phaseName === 'done'),
          first(),
        )
        .subscribe(() => {
          this.animatedText = text;
          this.state = 'in';
          this.cdRef.detectChanges();
        });
    } else {
      this.animatedText = text;
    }
  }

  private animationState$ = new Subject<AnimationEvent>();

  constructor(private cdRef: ChangeDetectorRef) {}

  public onAnimationDone($event: AnimationEvent): void {
    this.animationState$.next($event);
  }
}
